<div class="reviews-body" [formGroup]="formGroup">
  <div class="reviews-section">
    <div class="section-header">
      <span class="section-title">Import Method</span>
      <span class="section-subtitle">Choose how you'd like to import your product reviews.</span>
    </div>
    <pdq-review-platform-picker [formGroup]="formGroup"></pdq-review-platform-picker>
    @if (isCsvSelected) {
      <pdq-review-csv-upload [formGroup]="formGroup"></pdq-review-csv-upload>
    }
  </div>

  <pdq-divider></pdq-divider>

  <div class="reviews-section">
    <span class="section-title">Show</span>

    <pdq-slide-toggle
      label="Stars"
      formControlName="showStars"
      (onToggle)="onShowStarsToggled($event)"></pdq-slide-toggle>
    @if (formGroup.get('showStars')?.value) {
      <pdq-input-color
        label="Star Color"
        [control]="formGroup.get('starColor')"
        [formControl]="formGroup.get('starColor')"></pdq-input-color>
    }

    <pdq-slide-toggle
      label="Number of reviews"
      formControlName="showNumberOfReviews"
      (onToggle)="onShowNumberOfReviewsToggled($event)"></pdq-slide-toggle>
  </div>

  <pdq-divider></pdq-divider>

  <div class="reviews-section">
    <span class="section-title">Position</span>
    <pdq-radio-group formControlName="position">
      @for (option of positionOptions; track option.value) {
        <pdq-radio-button
          [value]="option.value"
          [checked]="formGroup.get('position')?.value === option.value"
          [text]="option.label"
          [subText]="option.helpText">
        </pdq-radio-button>
      }
    </pdq-radio-group>
  </div>

  <pdq-divider></pdq-divider>

  <div class="filters-section">
    <span class="filters-title">Filters</span>

    <div class="filter-row">
      <div class="rule-header">
        <span class="toggle-label">Star Rating</span>
        <pdq-slide-toggle formControlName="minStarRatingEnabled"></pdq-slide-toggle>
      </div>
      <span class="rule-description">Only show reviews with this rating or higher</span>
      @if (formGroup.get('minStarRatingEnabled')?.value) {
        <div class="rule-input-row">
          <pdq-input-arrows
            formControlName="minStarRating"
            [min]="minStarRatingMin"
            [max]="minStarRatingMax"
            [step]="minStarRatingStep"
            [precision]="1"
            widthSize="medium"></pdq-input-arrows>
          <span class="rule-inline-label">stars and above</span>
          <pdq-star-rating [rating]="formGroup.get('minStarRating')?.value"></pdq-star-rating>
        </div>
      }
    </div>

    <div class="filter-row">
      <div class="rule-header">
        <span class="toggle-label">Amount Of Reviews</span>
        <pdq-slide-toggle formControlName="minNumberOfReviewsEnabled"></pdq-slide-toggle>
      </div>
      <span class="rule-description">Only show reviews on products that have at least this many reviews</span>
      @if (formGroup.get('minNumberOfReviewsEnabled')?.value) {
        <div class="rule-input-row">
          <pdq-input-arrows formControlName="minNumberOfReviews" [min]="1" widthSize="medium"></pdq-input-arrows>
          <span class="rule-inline-label">reviews and above</span>
        </div>
      }
    </div>

    <div class="filter-row">
      <div class="rule-header">
        <span class="toggle-label">Exclude Products</span>
        <pdq-slide-toggle formControlName="excludeProductsEnabled"></pdq-slide-toggle>
      </div>
      <span class="rule-description">Reviews from these products won&apos;t show at checkout</span>

      @if (formGroup.get('excludeProductsEnabled')?.value) {
        <pdq-segmented-control
          [options]="exclusionModeOptions"
          [value]="isManualExclusion ? ExclusionMode.MANUAL : ExclusionMode.SMART"
          (valueChange)="setExclusionMode($event)">
        </pdq-segmented-control>

        @if (isManualExclusion) {
          <div class="product-list-section">
            <div class="product-list-section__header">
              <span class="product-list-section__label">Excluded Products ({{ excludedProducts.length }})</span>
              <pdq-button
                variant="dark"
                size="small"
                label="+Add Products"
                (onClick)="addExcludedProducts.emit()"></pdq-button>
            </div>
            <pdq-product-list
              [products]="excludedProducts"
              [showSearch]="true"
              [showRemove]="true"
              [currencySymbol]="shopCurrencySymbol"
              searchPlaceholder="Search..."
              emptyMessage="No products excluded"
              (remove)="removeExcludedProduct.emit($event.id)">
            </pdq-product-list>
          </div>
        } @else {
          <pdq-rules-dynamic-form
            [formGroup]="formGroup"
            formArrayFieldName="restrictionsRules"
            [rules]="excludeProductsRules | addCurrencyOption: shopCurrencySymbol"
            [entities]="excludeProductsEntities"
            [shopCurrencySymbol]="shopCurrencySymbol"
            [versionWithOrOperator]="true">
          </pdq-rules-dynamic-form>
        }
      }
    </div>
  </div>
</div>
